import React, { useState } from 'react';

const ConnectionStatus = ({ isConnected, isConnecting, lastDisconnect }) => {
  const [showDetails, setShowDetails] = useState(false);

  const getStatusIcon = () => {
    if (isConnecting) return '🔄';
    if (isConnected) return '🟢';
    return '🔴';
  };

  const getStatusText = () => {
    if (isConnecting) return 'Connecting...';
    if (isConnected) return 'Connected';
    return 'Disconnected';
  };

  const getStatusColor = () => {
    if (isConnecting) return '#ff9800';
    if (isConnected) return '#4caf50';
    return '#f44336';
  };

  const indicatorStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.5rem 1rem',
    background: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    border: `2px solid ${getStatusColor()}`,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };

  const indicatorHoverStyle = {
    ...indicatorStyle,
    background: 'white',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  };

  const iconStyle = {
    fontSize: '0.8rem',
    animation: isConnecting ? 'pulse 1.5s infinite' : 'none'
  };

  const textStyle = {
    fontSize: '0.8rem',
    fontWeight: 'bold',
    color: getStatusColor()
  };

  const detailsStyle = {
    position: 'absolute',
    top: '100%',
    right: 0,
    background: 'white',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '1rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    zIndex: 1000,
    minWidth: '200px',
    marginTop: '0.5rem'
  };

  const detailItemStyle = {
    marginBottom: '0.5rem',
    fontSize: '0.8rem'
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
      <div style={{ position: 'relative' }}>
        <div 
          style={indicatorStyle}
          onClick={() => setShowDetails(!showDetails)}
          title={`WebSocket ${getStatusText()}`}
          onMouseEnter={(e) => Object.assign(e.target.style, indicatorHoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, indicatorStyle)}
        >
          <span style={iconStyle}>{getStatusIcon()}</span>
          <span style={textStyle}>{getStatusText()}</span>
        </div>
        
        {showDetails && (
          <div style={detailsStyle}>
            <div style={detailItemStyle}>
              <strong>Status:</strong> {getStatusText()}
            </div>
            {lastDisconnect && (
              <div style={detailItemStyle}>
                <strong>Last disconnect:</strong> {new Date(lastDisconnect).toLocaleTimeString()}
              </div>
            )}
            <div style={{ ...detailItemStyle, marginBottom: 0 }}>
              <strong>Real-time:</strong> {isConnected ? 'Active' : 'Inactive'}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ConnectionStatus;
